import * as apiService from "./v2/apiService";
import { baseURL } from "@/constants/v2/endPoints";

const manageUrl = (id) => `${baseURL}api/v2/brokerage/manage/${id}/showcase`;
const PUBLIC_URL = `${baseURL}api/v2/public/showcase`;

export const getShowcase = (id) => apiService.apiCall(manageUrl(id), "GET", {});

export const saveShowcaseItems = (id, items) => apiService.apiCall(`${manageUrl(id)}/items`, "PUT", { items });

export const saveShowcaseSettings = (id, settings) => apiService.apiCall(manageUrl(id), "PUT", settings);

export const addShowcaseSite = (id, host) => apiService.apiCall(`${manageUrl(id)}/sites`, "POST", { host });

export const removeShowcaseSite = (id, siteId) =>
  apiService.apiCall(`${manageUrl(id)}/sites/${siteId}`, "DELETE", {});

export const startShowcaseCheckout = (id) => apiService.apiCall(`${manageUrl(id)}/checkout`, "POST", {});

export const confirmShowcaseCheckout = (id, sessionId) =>
  apiService.apiCall(`${manageUrl(id)}/checkout/confirm`, "POST", { sessionId });

export const openShowcasePortal = (id) => apiService.apiCall(`${manageUrl(id)}/portal`, "POST", {});

export const sendShowcaseGuide = (id, email) => apiService.apiCall(`${manageUrl(id)}/send-guide`, "POST", { email });

export const getPublicShowcase = (key, params) =>
  apiService.apiCallWithoutToken(`${PUBLIC_URL}/${encodeURIComponent(key)}`, "GET", params);

export const getPublicShowcaseBySlug = (slug, params) =>
  apiService.apiCallWithoutToken(`${PUBLIC_URL}/by-slug/${encodeURIComponent(slug)}`, "GET", params);

export const getPublicShowcaseItem = (key, wantAdId) =>
  apiService.apiCallWithoutToken(`${PUBLIC_URL}/${encodeURIComponent(key)}/items/${wantAdId}`, "GET", {});
